export const config = {
    appname: 'JCB',
    client_id: '905226923537745', // App ID
    facebook_app_id: '905226923537745', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'stg1service',
    agency_id: '',
    bzbsUrlOldSupport: 'https://stg.buzzebees.com',
    // bzbsUrl: 'https://stg1service.buzzebees.com',
    bzbsUrl: 'https://apijcb.buzzebees-uat.com',
    // bzbsModuleUrl: 'https://stg-module-jcb.azurewebsites.net',
    bzbsModuleUrl: 'https://jcbmodule.buzzebees-uat.com',
    // apiShoppingCartUrl: 'https://stg-module-shoppingcart.azurewebsites.net',
    apiShoppingCartUrl: 'https://shoppingcartmodule1.buzzebees-uat.com',
    // bzbsShoppingCartUrl: 'https://stg-web-shoppingcart1-apiservice.azurewebsites.net/',
    bzbsShoppingCartUrl: 'https://shoppingcartservice1.buzzebees-uat.com',
    bzbsBlobUrl: 'https://stgstoragebuzzebees.blob.core.windows.net',
    miscUrl: 'https://stgmisc.buzzebees.com',
    bzbsGaId: '',
    liffId: '1656625665-7zbp0PLl',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "AIzaSyCcLM6GhB4OjeX3XKnmZnI00Zcpg40EeeA",
        authDomain: "jcb-staging.firebaseapp.com",
        projectId: "jcb-staging",
        storageBucket: "jcb-staging.appspot.com",
        messagingSenderId: "784338541424",
        appId: "1:784338541424:web:2a6e75fa3668f1d57b0db5",
        measurementId: "G-2RYR7RY2GZ"
    },
};
